import { updateRundownCue } from '@/entities/rundown'

import { getCue } from '@/features/rundown/data/cues.store'

import type { SubTimer } from './sub-timers'

/**
 * Save a cue's sub timers. The list is written whole, built from the latest
 * cue in the store so a stale render cannot drop another change.
 *
 * No optimistic update: the Firestore listener is the only writer of cue data,
 * so the change shows once the snapshot arrives.
 */
export async function saveSubTimers(
  rundownId: string,
  cueId: string,
  update: (timers: SubTimer[]) => SubTimer[],
) {
  const cue = getCue(cueId)
  if (!cue) return
  const current = cue.subTimers.map((t) => ({ ...t }))
  await updateRundownCue({
    rundownId,
    cueId,
    payload: { subTimers: update(current) },
    params: {},
  })
}
